import type { Context, ReactNode } from 'react'
import React, { createContext } from 'react'
import { EventStackProvider } from '../use-event-stack'

// hookName is used by useEventStack to identify the hook when this provider isn't provided.
export const KeyboardShortcutsContext = createContext(null) as Context<unknown> & { hookName: string }

KeyboardShortcutsContext.hookName = 'useKeyboardShortcuts'

export const KeyboardShortcutsProvider = ({ children }: { children: ReactNode }): JSX.Element => (
  <EventStackProvider eventType="keydown" Context={KeyboardShortcutsContext}>
    {children}
  </EventStackProvider>
)
